<a
  class="sidebar-item no-decoration flex flex--middle"
  [class.active]="active()"
  [finLink]="link()"
  [external]="external()"
  [finElemTracker]="trackingObj()?.tracker"
  [finElemContext]="trackingObj()?.context"
  [finElemType]="trackingObj()?.type"
  [openInNewTab]="openInNewTab()"
  [attr.aria-current]="active() ? 'page' : null"
  [attr.aria-disabled]="active() ? 'true' : null"
  (click)="onLinkClick($event)"
  [ngClass]="['ps-large-r ps-small-l ' + styleClasses()]"
  tabindex="0"
>
  {{ title() }}
  @if (badge()) {
    <fcom-tag class="ms-large-l" data-testid="sidebar-item-badge" [theme]="TagTheme.PROMOTION">{{ badge() }}</fcom-tag>
  }
  @if (active()) {
    <span class="is-vishidden">{{ 'navigation.currentPage' | finLocalization }}</span>
  }
  @if (external()) {
    <fcom-icon
      class="icon-small ms-xxsmall-l"
      [dataTestId]="'icon-' + SvgLibraryIcon.EXTERNAL_TAB"
      [name]="SvgLibraryIcon.EXTERNAL_TAB"
    />
  }
  @if (loginRequired()) {
    <fcom-icon
      class="icon-small ms-xxsmall-l"
      [dataTestId]="'icon-' + SvgLibraryIcon.LOCK_OPEN"
      [name]="SvgLibraryIcon.LOCK_OPEN"
    />
  }
</a>
